import React from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import * as businessIntroductionDEActions from './BusinessIntroductionDE.actions';
import CompanySearchFooter from './CompanySearchFooter';
import CompanySearchInput from './CompanySearchInput';
import ManualCompanyAddressDE from './ManualCompanyAddressDE/ManualCompanyAddressDE';
import PostcodeFilter from './PostcodeFilter';
import * as actions from '../../actions';
import AutoCompany from '../../components/CompanyName/AutoCompany/AutoCompany';
import FormField from '../../components/FormField/';
import { getSchemaSpecificCompanyType } from '../../helpers/helpers';
import businessIntroductionDEMessages from '../BusinessIntroduction/BusinessIntroduction.messages';

const MAXIMUIM_RESULTS_FROM_COMPANY_SEARCH = 10;

const mapStateToProps = ({ fetched, ui }) => ({
    ui: ui,
    companies: fetched.companies
});

const mapDispatchToProps = (dispatch) => ({
    fetchCompaniesDE: (searchTerms) =>
        dispatch(
            businessIntroductionDEActions.fetchCompaniesDELending(searchTerms)
        ),
    resetFetchedCompanies: () =>
        dispatch(businessIntroductionDEActions.resetFetchedCompanies()),
    fetchLegalForm: (crefoId) =>
        dispatch(businessIntroductionDEActions.fetchLegalForm(crefoId)),
    toggleManualCompanyName: (index) =>
        dispatch(actions.toggleManualCompanyName(index))
});

class CompanySearch extends React.Component {
    componentDidUpdate = () => {
        const { companyField, fetchCompaniesDE, companies } = this.props;
        if (
            companyField.company_name.initialValue &&
            !Boolean(companyField.crefo_id.value) &&
            !companies.list.length &&
            !companies.fetching &&
            !companies.success
        ) {
            fetchCompaniesDE({
                companyName: companyField.company_name.initialValue
            });
        }
    };

    onCompanySelect = (selectedCompany) => {
        const { companyField, fetchLegalForm } = this.props;

        companyField.company_name.onChange(selectedCompany.name || '');
        companyField.address.street_line_1.onChange(
            selectedCompany.street_line_1 || ''
        );
        companyField.address.building_number.onChange(
            selectedCompany.building_number || ''
        );
        companyField.address.postcode.onChange(
            selectedCompany.postcode ? `${selectedCompany.postcode}` : ''
        );
        companyField.address.town.onChange(selectedCompany.town || '');

        const crefoId = selectedCompany.crefo_id;
        companyField.crefo_id.onChange(crefoId || '');
        fetchLegalForm(crefoId);
    };

    handleManualCompanySearchClick = () => {
        const clearFormFields = (fields) => {
            fields.forEach((field) => field.onChange(''));
        };
        const { companyField, ui, resetFetchedCompanies } = this.props;

        this.props.toggleManualCompanyName();
        clearFormFields([
            companyField.company_name,
            companyField.type,
            companyField.address.street_line_1,
            companyField.address.postcode,
            companyField.address.town,
            companyField.address.building_number
        ]);

        const isSwitchingToManualCompanySearch = !ui.manualCompanyName;
        resetFetchedCompanies();
        if (isSwitchingToManualCompanySearch) {
            clearFormFields([companyField.crefo_id]);
        } else {
            clearFormFields([
                companyField.address.building_number,
                companyField.address.street_line_2
            ]);
        }
    };

    render() {
        const {
            companyField,
            companies,
            ui: { manualCompanyName },
            fetchCompaniesDE,
            toggleManualCompanyName,
            resetFetchedCompanies,
            intl
        } = this.props;
        const companyType = getSchemaSpecificCompanyType(
            companyField.type.value
        );

        const sharedProps = {
            company: companyField,
            toggle: this.handleManualCompanySearchClick
        };

        const sectionHeaderMessage = manualCompanyName
            ? businessIntroductionDEMessages.companyAddress
            : businessIntroductionDEMessages.companySearch;
        const companiesFoundCount = companies.success
            ? companies.list.length
            : null;
        const hasMoreResults =
            companies.success &&
            companies.list.length >= MAXIMUIM_RESULTS_FROM_COMPANY_SEARCH;
        return (
            <div>
                <FormField.Header
                    message={<FormattedMessage {...sectionHeaderMessage} />}
                />

                {manualCompanyName ? (
                    <ManualCompanyAddressDE {...sharedProps} />
                ) : (
                    <AutoCompany
                        {...sharedProps}
                        companies={companies}
                        changeSearchTermOnNoCompanies={(currentSearchTerm) => ({
                            ...currentSearchTerm,
                            postcode: ''
                        })}
                        onSelect={this.onCompanySelect}
                        onCompanyNameChange={fetchCompaniesDE}
                        companyType={companyType}
                        locale="de"
                        useFieldError={true}
                        initialSearchTerm={{
                            companyName: companyField.company_name.value,
                            postcode: companyField.address.postcode.value
                        }}
                        renderSearch={CompanySearchInput({
                            resetFetchedCompanies,
                            companiesFoundCount,
                            hasMoreResults,
                            intl,
                            isPrefilledRegisteredCompanyWithoutCrefoId:
                                companyField.company_name.initialValue &&
                                !Boolean(companyField.crefo_id.value) &&
                                !companies.list.length &&
                                !companies.fetching &&
                                !companies.success
                        })}
                        renderTopMenuElement={PostcodeFilter({
                            hasMoreResults,
                            intl
                        })}
                        renderBottomMenuElement={CompanySearchFooter({
                            hasMoreResults,
                            toggleManualCompanyName
                        })}
                        onFocus={() => {
                            tracking.ampli.formFieldStarted({
                                form_field: 'auto_company_search'
                            });
                        }}
                    />
                )}
            </div>
        );
    }
}

const intlCompanySearch = injectIntl(CompanySearch);

export default connect(mapStateToProps, mapDispatchToProps)(intlCompanySearch);
